export const __ServiceNavigationLang = {
    buy: 'تخفیف‌های شهر',
    events: 'دورهمی و همراهی',
    home: 'خانه و هم‌خانه',
    friend: 'دوستیابی',
    hiring: 'کار و همکاری',
    close: 'بستن',
};
